import styled from "styled-components";
import breadcumdBg1 from "../../../assets/images/bg/breadcrumb.jpg";

const PageHeaderStyleWrapper = styled.div`
  background: url(${breadcumdBg1});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 100px 0;
  margin-top: 90px;

  .breadcrumb_area {
    font-family: "Poppins";

    .breadcrumb_menu {
      text-transform: uppercase;
      display: flex;
      align-items: center;
      font-size: 18px;
      color: #FF06B7;
      
      .icon {
        color: rgba(255, 255, 255);
        text-decoration: none;
        align-items: center;
        display: flex;
        cursor: pointer;
      }
      span {
        color: rgba(255, 255, 255);
        margin: 0 5px;
        font-size: 12px;

      }
      p{
        color: rgba(255, 255, 255);
        margin: 0;
        font-size: 15px;
        text-transform : capitalize;
      }
      .icon:hover {
        color: #FF06B7;
      }
    }

    .breadcrumb_title {
      color: white;
      text-transform: capitalize;
      font-size: 50px;
      font-weight: 700;
    }
  }

  .roadmap_phase {
    font-size: 48px;
    color: #ffffff;
    margin: 0;
    text-align: right;
  }

  @media only screen and (max-width: 991px) {
    .breadcrumb_area {
      .breadcrumb_title{
        font-size: 40px;
      }
    }
  }

  @media only screen and (max-width: 767px) {
    padding: 80px 0;

    .roadmap_phase {
      margin-top: 40px;
      text-align: left;
    }
  }
`;

export default PageHeaderStyleWrapper;
